export interface EconomicIntegrationConfig {
  tokenParamName: string;
  localStorageKey: string;
  redirectPath: string;
  integrationPath: string;
}

export const ECONOMIC_CONFIG: EconomicIntegrationConfig = {
  tokenParamName: "token",
  localStorageKey: "economicToken",
  redirectPath: "/",
  integrationPath: "/integration/e-conomic/connect",
};

export const extractAndStoreEconomicToken = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const economicToken = urlParams.get(ECONOMIC_CONFIG.tokenParamName);

  if (economicToken) {
    localStorage[ECONOMIC_CONFIG.localStorageKey] = economicToken;
    return economicToken;
  }

  return null;
};

export const isEconomicIntegrationPath = (): boolean => {
  return window.location.pathname.includes(ECONOMIC_CONFIG.integrationPath);
};

export const getStoredEconomicToken = (): string | null => {
  return localStorage.getItem(ECONOMIC_CONFIG.localStorageKey);
};

export const clearEconomicToken = (): void => {
  localStorage.removeItem(ECONOMIC_CONFIG.localStorageKey);
};

export const setPostIntegrationFlags = (): void => {
  localStorage.setItem("shouldStartFirstSync", "true");
  localStorage.setItem("shouldSelectWelcomeConversation", "true");
};
